// @file site.js
require('lity')

//
require('./utils')

// Components
require('./components/sentry')
require('./components/recaptcha')

// Modules
require('./modules/header')
require('./modules/dropdownMenu')
require('./modules/integrationsCarousel')
require('./modules/footerNavigation')
require('./modules/gdriveSwitch')
require('./modules/teamsDiagramsMobileNavigation')
require('./modules/pricing')
require('./modules/pricingPanel')
require('./modules/pricing-three-column-panel')
require('./modules/team')
require('./modules/customersSubpageCarousel')
require('./modules/quotesCarousel')
require('./modules/visioTemplatesCarousel')
require('./modules/pro')
require('./modules/contact')
require('./modules/floatingLabelControl')
require('./modules/signup')
require('./modules/signin')
require('./modules/education')
require('./modules/educationApply')
require('./modules/educationSignup')
require('./modules/teamSignup')
require('./modules/enterprise')
require('./modules/enterpriseContact')
require('./modules/resetPassword')
require('./modules/resetPasswordEmail')
require('./modules/teamSubpageCarousel')
require('./modules/invitationSignup')
require('./modules/marketo-form-clear')
require('./modules/case-study-slider')
require('./modules/add-external-link-icons')
require('./modules/templates/templates-slider')

// Pages
require('./pages/home')
require('./pages/examples')
require('./pages/contact')
require('./pages/integrations')
require('./pages/pricing')
require('./pages/team')
require('./pages/templates')
require('./pages/whiteboard')
require('./pages/pricing-new')
require('./pages/pricing-plan')

// SCSS
require('../scss/site.scss')
